import { Controller } from "@hotwired/stimulus"
import { startOsThemeObserver, syncThemeFromOs } from "../utils/theme_transition"

// Marqueur layout : préférence « auto ». L'écoute OS est centralisée (cf. startOsThemeObserver).
// Connects to data-controller="os-theme"
export default class extends Controller {
  connect() {
    startOsThemeObserver()
    syncThemeFromOs()
  }
}
